import { useContext } from 'react';
import { Stack, useTheme, Typography, Button, CustomTheme } from '@mui/material';
import { ClinexContext } from '../DiagnosisPages/Clinex/context';
import { DocumentScanner, Info } from '@mui/icons-material';
import { CLINEX_BAILED_OUT_MESSAGE, CLINEX_STATUS } from '../Constants';
import { useWindowSize } from 'shared-components/utils/CustomHooks';

export const ClinexBailedOutBanner = (): JSX.Element => {
  const theme = useTheme<CustomTheme>();
  const windowSize = useWindowSize();
  const isSmallDevice = windowSize.width < 1900;
  const { clinexStatus, setClinexModalOpen } = useContext(ClinexContext);
  if (clinexStatus !== CLINEX_STATUS.BAILED_OUT) {
    return <></>;
  }
  return (
    <div className="ro-careplan-banner">
      <Stack
        direction="row"
        alignItems="center"
        sx={{ gap: '12px', padding: '8px 16px', backgroundColor: theme.palette.alert.infoFill }}>
        <Info sx={{ color: theme.palette.info.main }} />
        <Typography variant="body2" className="clinex-warning-text">
          {CLINEX_BAILED_OUT_MESSAGE}
        </Typography>
        {isSmallDevice && (
          <Stack
            direction="row"
            alignItems="center"
            onClick={() => setClinexModalOpen(true)}
            sx={{ marginLeft: 'auto', gap: '8px', cursor: 'pointer' }}>
            <DocumentScanner sx={{ color: theme.palette.text.primary }} />
            <Typography variant="body2">VIEW DOCUMENTS</Typography>
          </Stack>
        )}
      </Stack>
    </div>
  );
};

export default ClinexBailedOutBanner;
